import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-export-data-studio',
  templateUrl: './help-add-export-data-studio.component.html',
  styleUrls: ['./help-add-export-data-studio.component.scss']
})
export class HelpAddExportDataStudioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
